import React, { useState } from 'react';
import Post from './Post';

export default function Feed() {
  var [posts, setPosts] = useState([
    {title: "Senior frontend develoepr", salary:"Promotional salary", time:"10 min", imgSrc: 'ppp.jpg', icon: true},
    {title: "Senior backend develoepr", salary:"Box shaodw", time:"45 min", imgSrc: 'pp1.jpg'},
    {title: "Senior frontend develoepr", salary:"Promotional salary", time:"10 min", imgSrc: 'ppp.jpg', icon: true},
    {title: "Junior database designer", salary:"Customizable duration", time:"45 min", imgSrc: 'pp.png', icon: true},
    {title: "Senior backend develoepr", salary:"Box shaodw", time:"45 min", imgSrc: 'pp1.jpg'},
    {title: "Senior backend develoepr", salary:"Box shaodw", time:"45 min", imgSrc: 'pp1.jpg'},
    {title: "Junior database designer", salary:"Customizable duration", time:"45 min", imgSrc: 'pp.png', icon: true},
  ]);


  return (
    <div className="feed">
      <h2>Job finder</h2>

      <form className="search">
        <div className="icon"><i className="fal fa-search"></i></div>
        <input type="text" placeholder="Search"/>
      </form>

      {posts.map(one => <Post title={one.title} salary={one.salary} imgSrc={one.imgSrc} time={one.time} body="Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aperiam, sequi! Nobis reprehenderit asperiores nulla. Illo natus non porro quibusdam blanditiis?" tags={['Design', 'Figma', 'Adobe']} icon={one.icon} />)}
    </div>
  )
}
